import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {QueryMediaVariablesType} from "../../definitions/types";
import {ItemClassificationType} from "../../definitions/enums";

const viewModel = window.viewModel;

export const name = "reviewMediaPagination";

const reviewMediaSlice = createSlice({
    name: name,
    initialState: {
        value: {
            id: viewModel.primaryId ?? viewModel.productId,
            type: viewModel.primaryId ? ItemClassificationType.Primary : ItemClassificationType.Standalone,
            productId: viewModel.productId,
            last: 25
        } as QueryMediaVariablesType
    },
    reducers: {
        update: (state, action: PayloadAction<Pick<QueryMediaVariablesType, "last" | "before">>) => {
            state.value.last = action.payload.last;
            state.value.before = action.payload.before;
        }
    }
});

export const {
    update: updateReviewMediaVariables
} = reviewMediaSlice.actions;
export default reviewMediaSlice.reducer;